(function () {
  var path = window.location.pathname || '';
  if (path.indexOf('/products/chatfield-j25-two-device-lora-mesh-communication-kit') === -1) return;
  if (document.querySelector('script[data-chatfield-j25-commerce-schema="true"]')) return;

  var productSchema = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: 'ChatField J25 two-device LoRa mesh communication kit',
    model: 'J25',
    sku: 'chatfield-j25-two-device-lora-mesh-communication-kit',
    url: window.location.origin + '/products/chatfield-j25-two-device-lora-mesh-communication-kit',
    image: window.location.origin + '/cdn/shop/files/j25-product.png',
    description:
      'Two-device ChatField J25 kit for phone-paired LoRa mesh off-grid communication. Each equipped teammate carries one J25 and uses a paired smartphone for PTT voice, text and voice messages, offline maps and team location beyond dependable cellular coverage.',
    brand: {
      '@type': 'Brand',
      name: 'ChatField'
    },
    manufacturer: {
      '@type': 'Organization',
      name: 'Jingxi Box (Shenzhen) Intelligent Technology Co., Ltd.'
    },
    category: 'Off-grid communication device',
    additionalProperty: [
      { '@type': 'PropertyValue', name: 'Kit size', value: 'Two J25 devices' },
      { '@type': 'PropertyValue', name: 'Communication model', value: 'Phone-paired LoRa mesh communication' },
      { '@type': 'PropertyValue', name: 'FCC ID', value: '2BVP9-J25' },
      {
        '@type': 'PropertyValue',
        name: 'Open-terrain ideal communication distance',
        value: 'Up to 10 km in plains, open line-of-sight routes or areas with limited hills'
      },
      { '@type': 'PropertyValue', name: 'Urban-obstructed field-test distance', value: 'Around 5 km' },
      {
        '@type': 'PropertyValue',
        name: 'Participating relay nodes',
        value: 'Up to two where configuration and field placement permit'
      }
    ],
    offers: {
      '@type': 'Offer',
      url: window.location.origin + '/products/chatfield-j25-two-device-lora-mesh-communication-kit',
      priceCurrency: 'USD',
      price: '598.00',
      availability: 'https://schema.org/InStock',
      itemCondition: 'https://schema.org/NewCondition',
      seller: {
        '@type': 'Organization',
        name: 'ChatField',
        email: 'vincent@chat-field.com'
      }
    }
  };

  var faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'What does one US$598 ChatField J25 order contain?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'One order is a two-device J25 kit. It is intended to equip two teammates; it is not a four-device package.'
        }
      },
      {
        '@type': 'Question',
        name: 'Does ChatField J25 work without a phone?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'The current J25 is designed to work with a compatible paired smartphone. The phone remains the interface for PTT, messages, offline maps and team-location workflows.'
        }
      },
      {
        '@type': 'Question',
        name: 'What communication range should buyers expect?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'ChatField reports an ideal communication distance of up to 10 km in open terrain such as plains, open line-of-sight routes or areas with limited hills, and around 5 km in urban conditions with high-rise buildings and structural obstructions. Real performance depends on terrain, buildings, vegetation, interference, antenna position and node placement.'
        }
      },
      {
        '@type': 'Question',
        name: 'Is PayPal already available for J25 checkout?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: "Payment methods are controlled by the merchant's Shopify checkout configuration. PayPal appears only after it has been activated by the merchant."
        }
      },
      {
        '@type': 'Question',
        name: 'Where can company buyers request B2B pricing?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Company buyers can use the B2B inquiry page, WhatsApp +86 186 6622 7121 or email vincent@chat-field.com to request volume pricing, samples, OEM/ODM support and destination-market documents.'
        }
      }
    ]
  };

  [productSchema, faqSchema].forEach(function (schema) {
    var script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-chatfield-j25-commerce-schema', 'true');
    script.text = JSON.stringify(schema);
    document.head.appendChild(script);
  });
})();
